import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TargetObjectService {

  constructor(public rest: RestService) { }

  public getObjects(webpage_id): Observable<any[]> {
    return this.rest.get('webpagetargetobject', webpage_id);
  }
  
  public getObjectsdb2(webpage_id): Observable<any[]> {
    return this.rest.get('webpagetargetobjectdb2', webpage_id);
  }
}
